export const dateFormat = 'YYYY-MM-DD';

export const tableTypes = {
  ACTION: 'action',
  MODAL: 'modal',
  FILE: 'file',
  PHONE: 'phone',
  VIDEO: 'video',
  IMAGE: 'image',
  NUMBER: 'number',
  RERENDER: 'rerender',
  CHECK_MARK: 'check_mark',
  DYNAMIC_COLUMN: 'dynamic_column_names',
} as const;

export const PRIVATE_CODE = {
  CLIENT: 'minicli',
  KIOSK: 'minikio',
  MINIBAR: 'minimini',
  APP: 'miniapp',
  AD: 'miniad',
  ERROR_HISTORY: 'minikioerr',
  MEMBER: 'minimemb',
} as const;

export const MAX_WELFARE_POINTS = 10000000;

export const WELFARE_MAX_POINT = 850_000;

export const MAX_INT = 2147483647;

export const MAX_INT_VALUE = 2_147_483_647;

interface CurrencyUnit {
  unit: number;
  abbreviations: string;
}

export const currencyUnitData: CurrencyUnit[] = [
  {
    unit: 1_000,
    abbreviations: '천',
  },
  {
    unit: 10_000,
    abbreviations: '만',
  },
  {
    unit: 100_000,
    abbreviations: '십만',
  },
  {
    unit: 1_000_000,
    abbreviations: '백만',
  },
  {
    unit: 10_000_000,
    abbreviations: '천만',
  },
  {
    unit: 100_000_000,
    abbreviations: '억',
  },
  // {
  //   unit: 1_000_000_000,
  //   abbreviations: '십억'
  // },
  // {
  //   unit: 10_000_000_000,
  //   abbreviations: '백억'
  // },
  // {
  //   unit: 100_000_000_000,
  //   abbreviations: '천억'
  // },
  // {
  //   unit: 1_000_000_000_000,
  //   abbreviations: '조'
  // }
];

export const scopes = {
  SUPER: 'SUPER',
  ADMIN: 'ADMIN',
  ADMIN_PRODUCT_MASTER: 'ADMIN_PRODUCT_MASTER',
  ADMIN_INVENTORY_MASTER: 'ADMIN_INVENTORY_MASTER',
  ADMIN_WAREHOUSE_MASTER: 'ADMIN_WAREHOUSE_MASTER',
  ADMIN_DISPLAY_MANAGER: 'ADMIN_DISPLAY_MANAGER',
} as const;

export const CHANNELS = {
  ALL: 'B2B,B2C,B2B2C',
  B2C: 'B2C',
  B2B: 'B2B',
  B2B2C: 'B2B2C',
} as const;

export const LOCATION_TYPES = {
  BUFFER: 'BUFFER',
  VIRTURAL: 'VIRTUAL',
  PICKING: 'PICKING',
} as const;

export const PICKING_STATUSES = {
  ONGOING: 'ONGOING',
  REQUESTED: 'REQUESTED',
  REGISTERED: 'REGISTERED',
  COMPLETED: 'COMPLETED',
  CONFIRMED: 'CONFIRMED',
  REJECTED: 'REJECTED',
} as const;

export const MINIBAR_OWNERSHIP_TYPES = {
  CLIENT_OWNED: 'CLIENT_OWNED',
  COMPANY_OWNED: 'COMPANY_OWNED',
} as const;

export const COUPON_STATUSES = {
  WAITING: 'PENDING', // Waiting for issuance
  COMPLETED: 'ACTIVE', // Issuance completed
  FINISHED: 'ENDED', // Issuance finished
  CANCELED: 'CANCELED', // Issuance canceled
} as const;

export const COUPON_CREATION_TYPES = {
  MANUAL: 'IMMEDIATE_ISSUANCE',
  COUPONCODE: 'REGISTRATION_CODE',
} as const;

export const COUPON_TYPES = {
  FIXED: 'FIXED_AMOUNT',
  PERCENTAGE: 'PERCENTAGE',
} as const;
